
<div class="container margin-top pb-3" *ngIf="BillDetails !== undefined">
  <div class="alert alert-warning alert-dismissible fade show d-flex align-items-start" role="alert">
    <i class="fas fa-exclamation-triangle mr-2 mt-1"></i>
  
    <div class="flex-grow-1">
      Unsere Rechnungen stehen ab sofort als PDF mit eingebetteter XML sowie zusätzlich als separate ZUGFeRD-XML-Datei zur Verfügung.
      Da einige Systeme nur reine XML-Dateien verarbeiten können, stellen wir beide Formate bereit. Bitte nutzen Sie das für Ihr System passende Format.
    </div>
  
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <app-timed-message [alert]="timedMessage"></app-timed-message>
  <div class="d-flex flex-sm-wrap">
    <div class="p-2 flex-sm-fill">
      <span style="font-weight: bold;font-size: x-large">Rechnungsdetails</span><br>
      <a [routerLink]="['/Billing/List']" style="font-size: x-small;">
        <i class="fa fa-angle-double-left"></i> Zur Rechnungsübersicht
      </a></div>
  </div>

  <div class="border rounded mb-3">
    <div class="d-flex flex-sm-wrap">
      <div class="p-2 flex-sm-fill">
        {{'billingNumber' | translate}} <br> 
        <b>{{ BillDetails[0].Rechnungsnummer }}</b>
      </div>
    
      <div class="p-2 flex-sm-fill">
        {{'date' | translate}} <br> 
        <b>{{ BillDetails[0].Rechnungsdatum }}</b>
      </div>
    
      <div class="p-2 flex-sm-fill text-right">
        <div class="d-flex flex-column align-items-end">
          <span class="mb-1">Download</span>
          <div class="download-box d-flex flex-row flex-wrap">
            <button class="btn btn-sm rounded btn-outline-secondary d-flex flex-column align-items-center text-center ml-2"
                    (click)="showFiles(BillDetails[0].DocumentID)">
              <i class="fas fa-file-pdf text-danger mb-1"></i>
              <span>Rechnung <span class="marker">{{ BillDetails[0].UserInformed ? '' : ' *' }}</span></span>
            </button>
      
            <ng-container *ngFor="let bill of BillAttachments; let i = index">
              <ng-container *ngIf="bill !== 0">
                <button *ngIf="bill.AnhangID !== 0"
                        class="btn btn-sm rounded btn-outline-secondary d-flex flex-column align-items-center text-center ml-2"
                        (click)="showFiles(bill)">
                  <i class="fas fa-file-alt mb-1"></i>
                  <span>Anhang {{ i + 1 }} <span class="marker">{{ BillDetails[0].UserInformed ? '' : ' *' }}</span></span>
                </button>
              </ng-container>
            </ng-container>


            <ng-container *ngFor="let bill of BillXML; let i = index">
              <ng-container *ngIf="bill !== 0">
                <button class="btn btn-sm rounded btn-outline-secondary d-flex flex-column align-items-center text-center ml-2"
                        (click)="showFiles(BillXML)">
                  <i class="fas fa-file-code text-warning mb-1"></i>
                  <span>ZUGFeRD-XML {{ i + 1 }} <span class="marker">{{ BillDetails[0].UserInformed ? '' : ' *' }}</span></span>
                </button>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    

    <div class="table-responsive">
      <table class="table table-striped table-sm-sm">
        <thead>
        <tr>
          <th class="text-center">Menge</th>
          <th class="text-left">Bezeichnung</th>
          <th class="text-right">Einzelpreis Netto</th>
          <th class="text-right">Gesamt Netto</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let bill of BillDetails">
          <td class="text-center">{{ bill.Menge }}</td>
          <td class="text-left"><b>{{ bill.Beschreibung }}</b>
            <p>Leistungszeitraum: {{ bill.LeistungAb }} - {{ bill.LeistungBis }}</p></td>
          <td class="text-right">{{ bill.Netto }} €</td>
          <td class="text-right">{{ bill.GesamtNetto }} €</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex flex-sm-wrap border-top justify-content-end">
      <div class="p-2">
        <div class="d-flex">
          <span class="netto">Betrag netto: </span>
          <span class="betrag ml-1 text-right">{{ BillDetails[0].SummeNetto }} €</span>
        </div>
        <div class="d-flex justify-content-end">
          <span class="mwst">(Zuzüglich der gesetzlichen Mehrwertsteuer)</span>
        </div>

      </div>
    </div>

  </div>
</div>
